import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  serviceName = 'loginService';
  resetFormEvent: Subject<void> = new Subject<void>();

  constructor(
    private http: HttpClient,
    @Inject('environment') public environment: any
  ) {}

  login(userInfo: any) {
    return this.http.post(
      `${this.environment.apiUrl}/login`,
      { userInfo }
    );
  }

  OBOlogin(userInfo: any) {
    return this.http.post(
      `${this.environment.apiUrl}/login/obo`,
      { userInfo }
    );
  }
  triggerFormReset() {
    this.resetFormEvent.next();
  }
}
